module.exports = __webpack_public_path__ + "media/images/smile-icon-01618db71a551334db0ac606b8a5e65a.png";